import type { Stripe } from "@stripe/stripe-js";
import type { CreatePaymentIntentResponse } from "../api/mutations/useMakePayment";

/**
 * Backend creates PaymentIntents with Confirm=true, so payment may already succeed server-side.
 * Only call confirmCardPayment when 3DS or further client action is still required.
 */
export async function completeStripePaymentFromIntent(
  stripe: Stripe,
  response: CreatePaymentIntentResponse,
  paymentMethodId: string
): Promise<{ success: true } | { success: false; message: string }> {
  if (response.noPaymentRequired || response.paymentAlreadySucceeded) {
    return { success: true };
  }

  const clientSecret = response.clientSecret;
  if (!clientSecret) {
    return { success: false, message: "No client secret returned." };
  }

  const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret, {
    payment_method: paymentMethodId,
  });

  if (error) {
    return {
      success: false,
      message: error.message || "Payment confirmation failed.",
    };
  }

  const status = paymentIntent?.status;
  if (status === "succeeded" || status === "processing") {
    return { success: true };
  }

  return {
    success: false,
    message: `Payment could not be completed (status: ${status ?? "unknown"}).`,
  };
}
